module.exports = __webpack_public_path__ + "static/img/4.0958230.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/4.png
// module id = CCKS
// module chunks = 0